(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-background"] && !Shopify.designMode) return;
  try {
    
  {
    const WRAPPER_CLASS = 'custom-background-wrapper';
    const CONTROLLER_SELECTOR = '.background-wrapper-controller';

    class BackgroundWrapper {
      constructor(controllerElement) {
        this.controller = controllerElement;
        const { sectionId, enabled, sectionsToCover, bgImageUrl, bgImageOpacity, topGradient, bottomGradient } =
          this.controller.dataset;

        this.sectionId = sectionId;
        this.isEnabled = enabled === 'true';
        this.sectionsToCover = parseInt(sectionsToCover, 10) || 0;
        this.controllerSection = this.controller.closest('.shopify-section');

        // Background properties are only relevant if the feature is enabled
        if (this.isEnabled) {
          this.imageUrl = bgImageUrl;
          this.opacity = parseFloat(bgImageOpacity);
          this.topGradient = topGradient;
          this.bottomGradient = bottomGradient;
        }
      }

      /**
       * Initializes the wrapper logic. It cleans up any previous state
       * and then, if enabled, wraps the target sections after a brief
       * delay to ensure the DOM is stable, especially in the theme editor.
       */
      init() {
        this.cleanup();
        if (this.isEnabled && this.controllerSection) {
          // Use a small timeout to let the DOM settle before manipulation
          setTimeout(() => this.wrapSections(), 50);
        }
      }

      /**
       * Finds subsequent sibling sections and wraps them in a new container div.
       * This new div is styled with the specified background image and gradients.
       */
      wrapSections() {
        if (!this.imageUrl) return;

        const sectionsToWrap = this.collectSectionsToWrap();
        if (sectionsToWrap.length === 0) return;

        // Hide the controller section element from the layout
        this.controllerSection.style.display = 'none';

        const wrapper = this.createWrapperElement();

        // Insert wrapper into the DOM before the first section to be wrapped
        sectionsToWrap[0].parentNode.insertBefore(wrapper, sectionsToWrap[0]);

        // Move the collected sections inside the new wrapper
        sectionsToWrap.forEach((section) => wrapper.appendChild(section));
      }

      /**
       * Gathers the DOM elements of the sections that need to be wrapped.
       * @returns {HTMLElement[]} An array of section elements.
       */
      collectSectionsToWrap() {
        const sections = [];
        let currentSibling = this.controllerSection.nextElementSibling;

        for (let i = 0; i < this.sectionsToCover && currentSibling; i++) {
          if (currentSibling.querySelector(CONTROLLER_SELECTOR) || currentSibling.classList.contains(WRAPPER_CLASS)) {
            break;
          }
          sections.push(currentSibling);
          currentSibling = currentSibling.nextElementSibling;
        }
        return sections;
      }

      /**
       * Creates and styles the wrapper div element with multiple background layers.
       * @returns {HTMLElement} The configured wrapper div.
       */
      createWrapperElement() {
        const wrapper = document.createElement('div');
        wrapper.className = WRAPPER_CLASS;
        wrapper.dataset.wrapperFor = this.sectionId;

        const backgroundLayers = [];

        // Layer 1: Top Gradient (if set and not 'none')
        if (this.topGradient && this.topGradient !== 'none') {
          backgroundLayers.push(this.topGradient);
        }

        // Layer 2: Bottom Gradient (if set and not 'none')
        if (this.bottomGradient && this.bottomGradient !== 'none') {
          backgroundLayers.push(this.bottomGradient);
        }

        // Layer 3: Opacity overlay
        const overlayAlpha = 1 - this.opacity;
        const whiteOverlay = `linear-gradient(rgba(255, 255, 255, ${overlayAlpha}), rgba(255, 255, 255, ${overlayAlpha}))`;
        backgroundLayers.push(whiteOverlay);

        // Layer 4: The actual background image
        backgroundLayers.push(`url('${this.imageUrl}')`);

        // Combine all layers. CSS layers are comma-separated.
        wrapper.style.backgroundImage = backgroundLayers.join(', ');
        wrapper.style.backgroundSize = 'cover';
        wrapper.style.backgroundPosition = 'center'; // Hardcoded to center
        return wrapper;
      }

      /**
       * Reverts the DOM changes made by this instance. It unwraps the
       * sections and removes the wrapper div, restoring the original structure.
       */
      cleanup() {
        const wrapper = document.querySelector(`.${WRAPPER_CLASS}[data-wrapper-for="${this.sectionId}"]`);
        if (!wrapper) return;

        const parent = wrapper.parentNode;

        // Move all children out of the wrapper, placing them *before* the wrapper itself.
        // This preserves their original order.
        while (wrapper.firstChild) {
          parent.insertBefore(wrapper.firstChild, wrapper);
        }

        wrapper.remove();

        if (this.controllerSection) {
          this.controllerSection.style.display = '';
        }
      }
    }

    // --- Theme Editor & Storefront Event Handling ---
    const instances = new Map();

    const manageInstance = (element, action) => {
      const controller = element.querySelector(CONTROLLER_SELECTOR);
      if (!controller) return;

      const sectionId = controller.dataset.sectionId;
      const existingInstance = instances.get(sectionId);

      if (action === 'cleanup' && existingInstance) {
        existingInstance.cleanup();
        instances.delete(sectionId);
      }

      if (action === 'init') {
        if (existingInstance) existingInstance.cleanup();
        const newInstance = new BackgroundWrapper(controller);
        instances.set(sectionId, newInstance);
        newInstance.init();
      }
    };

    const initAll = () => {
      document.querySelectorAll('.shopify-section').forEach((section) => manageInstance(section, 'init'));
    };

    const cleanupAll = () => {
      instances.forEach((instance) => instance.cleanup());
      instances.clear();
    };

    const reinitAll = () => {
      cleanupAll();
      initAll();
    };

    document.addEventListener('DOMContentLoaded', initAll);

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => manageInstance(e.target, 'init'));
      document.addEventListener('shopify:section:unload', (e) => manageInstance(e.target, 'cleanup'));
      document.addEventListener('shopify:section:select', (e) => manageInstance(e.target, 'init'));
      document.addEventListener('shopify:section:reorder', reinitAll);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
